import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';

const ReportDataHeader = ({
    data,
    dataType,
}) => (
    <>
        <Typography variant="h5" component="p">
            {`${dataType}: `}
        </Typography>
        <Typography variant="h1" component="p">
            {data}
        </Typography>
    </>
);

ReportDataHeader.propTypes = {
    data: PropTypes.string.isRequired,
    dataType: PropTypes.string.isRequired,
};

export default ReportDataHeader;
